import React, { lazy } from "react";
import { WithFeatureFlagRoute, withSuspense } from "../routes.tsx";

const GoalsPage = lazy(() =>
  import("@features/goals/GoalsPage.tsx").then((module) => ({
    default: module.GoalsPage,
  }))
);

const GoalDetailPage = lazy(() =>
  import("@features/goals/GoalDetailPage.tsx").then((module) => ({
    default: module.GoalDetailPage,
  }))
);

const GoalWizardPage = lazy(() =>
  import("@features/goals/GoalWizardPage.tsx").then((module) => ({
    default: module.GoalWizardPage,
  }))
);

export default [
  {
    path: "goals",
    element: <WithFeatureFlagRoute featureFlag="GOALS" />,
    children: [
      {
        index: true,
        element: withSuspense(GoalsPage),
      },
      {
        path: "new",
        element: withSuspense(GoalWizardPage),
      },
      {
        path: ":goalId",
        element: withSuspense(GoalDetailPage),
      },
      {
        path: ":goalId/edit",
        element: withSuspense(GoalWizardPage),
      },
    ],
  },
];
